import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend';
import { ICONS } from '@app/styles';
import './PopUp_UtilitiesMenu.scss';
import { Menu_AdvisorSettings } from '../../menus/Menu_AdvisorSettings/Menu_AdvisorSettings.js';
import { ModuleFE_AdvisorSession, ModuleFE_AdvisorState, ModuleFE_EMInterface } from '@app/advisor-frontend';
import { Component_SupportReport } from '../../dialogs/support-report-dialog/Component_SupportReport.js';
import { supportType_Bug } from '@app/advisor-shared';
import { ModuleFE_Spotlight } from '../../../modules/ModuleFE_Spotlight/ModuleFE_Spotlight.js';
import { spotlightMode_Support } from '../../../modules/ModuleFE_Spotlight/types.js';
import { Dialog_ProviderChat } from '../../dialogs/Dialog_ProviderChat/Dialog_ProviderChat.js';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
export class PopUp_UtilitiesMenu extends ComponentSync {
    //######################### Static #########################
    static popUpKey = 'pu__utilities-menu';
    static show = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const model = {
            id: PopUp_UtilitiesMenu.popUpKey,
            content: () => _jsx(PopUp_UtilitiesMenu, {}),
            originPos: { x: rect.right, y: rect.bottom },
            modalPos: { x: -1, y: 1 },
            offset: { y: 10 },
        };
        ModuleFE_MouseInteractivity.showContent(model);
        ModuleFE_AdvisorAnalytics.trigger.view.view_utilityMenu();
    };
    static close = () => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    };
    //######################### Render #########################
    render() {
        return _jsxs(_Fragment, { children: [this.renderButton_Settings(), this.renderButton_BugReport(), this.renderButton_FAQ(), this.renderButton_MagicWand()] });
    }
    renderButton_Settings = () => {
        return _jsxs(Button, { onClick: () => {
                PopUp_UtilitiesMenu.close();
                Menu_AdvisorSettings.show();
            }, children: ["Settings", _jsx(ICONS.advisor_avn_gear.component, {})] });
    };
    renderButton_BugReport = () => {
        const canCreateBugReport = ModuleFE_EMInterface.canCreateBugReport();
        return _jsxs(Button, { disabled: !canCreateBugReport, onClick: () => {
                PopUp_UtilitiesMenu.close();
                Component_SupportReport.show({ type: supportType_Bug });
            }, children: ["Bugs", _jsx(ICONS.advisor_avn_bug.component, {})] });
    };
    renderButton_FAQ = () => {
        return _jsxs(Button, { onClick: () => {
                const supportOpen = ModuleFE_Spotlight.getSpotlightData()?.mode === spotlightMode_Support;
                PopUp_UtilitiesMenu.close();
                if (!supportOpen)
                    return ModuleFE_Spotlight.openSupport();
            }, children: ["FAQ", _jsx(ICONS.advisor_v5_support.component, {})] });
    };
    renderButton_MagicWand = () => {
        const advisorConfig = ModuleFE_AdvisorSession.getAdvisorConfig();
        const magicWandEnabled = advisorConfig.magicWand && ModuleFE_AdvisorState.getStateProperty.featureFlag.magicWand();
        if (!magicWandEnabled)
            return;
        return _jsxs(Button, { onClick: () => {
                PopUp_UtilitiesMenu.close();
                Dialog_ProviderChat.show();
            }, children: ["Magic Wand", _jsx(ICONS.advisor_v5_wand.component, { "data-variant": 'menu-icon' })] });
    };
}
//# sourceMappingURL=PopUp_UtilitiesMenu.js.map